import React from 'react';
import { AuthDataContext } from './context';

export const useAuthData = () => React.useContext(AuthDataContext).authData;

export const useSetAuthData = () => React.useContext(AuthDataContext).setAuthData;

export const useGetServerEnv = () => React.useContext(AuthDataContext).getServerEnv;

export const useAuthenticate = () => React.useContext(AuthDataContext).authenticate;

export const useResetForm = () => React.useContext(AuthDataContext).resetForm;

export const useSubmitLogin = () => React.useContext(AuthDataContext).submitLogin;
